import Vue from 'vue'
import Vuex from 'vuex'

import { IConnectModel, IUserModel } from '@/models/account.model';
import { ITokenModel } from '@/models/token.model';
import { ICookieModel } from '@/models/cookie.model';
import { IAgeGateSettingsModel, ISSODataModel } from '@/models/login.model';
import { IPrivacyLinksModel } from './models/platform.model';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {} as IUserModel,
    token: {} as ITokenModel,
    SSORegisterCode: '',
    SSOId: 0,
    SSOEmail: '',
    clientId: '',
    redirectUrl: '',
    username: '',
    isLoading: false,
    isLinkingSteamLoading: false,
    isLinkingTwitchLoading: false,
    isLinkingEpicGamesLoading: false,
    isRefreshTwitchLoading: false,
    isRefreshEpicGamesLoading: false,
    isLinkingCallbackLoading: false,
    isRefreshSteamLoading: false,
    connects: new Array<IConnectModel>(),
    cookies: new Array<ICookieModel>(),
    key: '',
    ssoData: {} as ISSODataModel,
    ageGateSettings: { IsActive: false } as IAgeGateSettingsModel,
    privacyLinks: { PrivacyPolicy: '', CookiePolicy: '', TermsOfService: '' } as IPrivacyLinksModel,
    platformName: '',
  },

  getters: {
    user: state => {
      return state.user;
    },
    connects: state => {
      return state.connects;
    },
    cookies: state => {
      return state.cookies;
    },
    token: state => {
      return state.token;
    },
    SSORegisterCode: state => {
      return state.SSORegisterCode;
    },
    SSOId: state => {
      return state.SSOId;
    },
    SSOEmail: state => {
      return state.SSOEmail;
    },
    username: state => {
      return state.username;
    },
    clientId: state => {
      return state.clientId;
    },
    redirectUrl: state => {
      return state.redirectUrl;
    },
    isLoading: state => {
      return state.isLoading;
    },
    isLinkingSteamLoading: state => {
      return state.isLinkingSteamLoading;
    },
    isLinkingTwitchLoading: state => {
      return state.isLinkingTwitchLoading;
    },
    isLinkingEpicGamesLoading: state => {
      return state.isLinkingEpicGamesLoading;
    },
    isRefreshTwitchLoading: state => {
      return state.isRefreshTwitchLoading;
    },
    isRefreshEpicGamesLoading: state => {
      return state.isRefreshEpicGamesLoading;
    },
    isRefreshSteamLoading: state => {
      return state.isRefreshSteamLoading;
    },
    isLinkingCallbackLoading: state => {
      return state.isLinkingCallbackLoading;
    },
    accessKey: state => {
      return state.key;
    },
    ssoData: state => {
      return state.ssoData;
    },
    ageGateSettings: state => {
      return state.ageGateSettings;
    },
    privacyLinks: state => {
      return state.privacyLinks;
    },
    platformName: state => {
      return state.platformName;
    }
  },

  mutations: {
    updateUser(state, user: IUserModel) {
      state.user = user;
    },
    updateConnect(state, connects: Array<IConnectModel>) {
      state.connects = connects;
    },
    updateCookies(state, cookies: Array<ICookieModel>) {
      state.cookies = cookies;
    },
    updateToken(state, token: ITokenModel) {
      state.token = token;
    },
    updateSSORegisterCode(state, SSORegisterCode: string) {
      state.SSORegisterCode = SSORegisterCode;
    },
    updateSSOId(state, SSOId: number) {
      state.SSOId = SSOId;
    },
    updateSSOEmail(state, SSOEmail: string) {
      state.SSOEmail = SSOEmail;
    },
    updateUsername(state, username: string) {
      state.username = username;
    },
    updateClientId(state, clientId: string) {
      state.clientId = clientId;
    },
    updateRedirectUrl(state, redirectUrl: string) {
      state.redirectUrl = redirectUrl;
    },
    updateIsLoading(state, isLoading: boolean) {
      state.isLoading = isLoading;
    },
    updateIsLinkingSteamLoading(state, isLinkingSteamLoading: boolean) {
      state.isLinkingSteamLoading = isLinkingSteamLoading;
    },
    updateIsLinkingTwitchLoading(state, isLinkingTwitchLoading: boolean) {
      state.isLinkingTwitchLoading = isLinkingTwitchLoading;
    },
    updateIsLinkingEpicGamesLoading(state, isLinkingEpicGamesLoading: boolean) {
      state.isLinkingEpicGamesLoading = isLinkingEpicGamesLoading;
    },
    updateIsRefreshTwitchLoading(state, isRefreshTwitchLoading: boolean) {
      state.isRefreshTwitchLoading = isRefreshTwitchLoading;
    },
    updateIsRefreshEpicGamesLoading(state, isRefreshEpicGamesLoading: boolean) {
      state.isRefreshEpicGamesLoading = isRefreshEpicGamesLoading;
    },
    updateIsRefreshSteamLoading(state, isRefreshSteamLoading: boolean) {
      state.isRefreshSteamLoading = isRefreshSteamLoading;
    },
    updateIsLinkingCallbackLoading(state, isLinkingCallbackLoading: boolean) {
      state.isLinkingCallbackLoading = isLinkingCallbackLoading;
    },
    updateAccessKey(state, key: string) {
      state.key = key;
    },
    updateSSOData(state, ssoData: ISSODataModel) {
      state.ssoData = ssoData;
    },
    updateAgeGateSettings(state, ageGateSettings: IAgeGateSettingsModel) {
      state.ageGateSettings = ageGateSettings;
    },
    updatePrivacyLinks(state, privacyLinks: IPrivacyLinksModel) {
      state.privacyLinks = privacyLinks;
    },
    updatePlatformName(state, platformName: string) {
      state.platformName = platformName;
    }
  },

  actions: {
    updateUser(context, user: IUserModel) {
      context.commit('updateUser', user);
    },
    updateConnect(context, connects: Array<IConnectModel>) {
      context.commit('updateConnect', connects)
    },
    updateCookies(context, cookies: Array<ICookieModel>) {
      context.commit('updateCookies', cookies)
    },
    updateToken(context, token: ITokenModel) {
      context.commit('updateToken', token);
    },
    updateSSORegisterCode(context, SSORegisterCode: string) {
      context.commit('updateSSORegisterCode', SSORegisterCode);
    },
    updateSSOId(context, SSOId: number) {
      context.commit('updateSSOId', SSOId);
    },
    updateSSOEmail(context, SSOEmail: string) {
      context.commit('updateSSOEmail', SSOEmail);
    },
    updateUsername(context, username: string) {
      context.commit('updateUsername', username);
    },
    updateClientId(context, clientId: string) {
      context.commit('updateClientId', clientId);
    },
    updateRedirectUrl(context, redirectUrl: string) {
      context.commit('updateRedirectUrl', redirectUrl);
    },
    updateIsLoading(context, isLoading: boolean) {
      context.commit('updateIsLoading', isLoading);
    },
    updateIsLinkingSteamLoading(context, isLinkingSteamLoading: boolean) {
      context.commit('updateIsLinkingSteamLoading', isLinkingSteamLoading);
    },
    updateIsLinkingTwitchLoading(context, isLinkingTwitchLoading: boolean) {
      context.commit('updateIsLinkingTwitchLoading', isLinkingTwitchLoading);
    },
    updateIsLinkingEpicGamesLoading(context, isLinkingEpicGamesLoading: boolean) {
      context.commit('updateIsLinkingEpicGamesLoading', isLinkingEpicGamesLoading);
    },
    updateIsRefreshTwitchLoading(context, isRefreshTwitchLoading: boolean) {
      context.commit('updateIsRefreshTwitchLoading', isRefreshTwitchLoading);
    },
    updateIsRefreshEpicGamesLoading(context, isRefreshEpicGamesLoading: boolean) {
      context.commit('updateIsRefreshEpicGamesLoading', isRefreshEpicGamesLoading);
    },
    updateIsRefreshSteamLoading(context, isRefreshSteamLoading: boolean) {
      context.commit('updateIsRefreshSteamLoading', isRefreshSteamLoading);
    },
    updateIsLinkingCallbackLoading(context, isLinkingCallbackLoading: boolean) {
      context.commit('updateIsLinkingCallbackLoading', isLinkingCallbackLoading);
    },
    updateAccessKey(context, key: string) {
      context.commit('updateAccessKey', key);
    },
    updateSSOData(context, ssoData: ISSODataModel) {
      context.commit('updateSSOData', ssoData);
    },
    updateAgeGateSettings(context, ageGateSettings: IAgeGateSettingsModel) {
      context.commit('updateAgeGateSettings', ageGateSettings);
    },
    updatePrivacyLinks(context, privacyLinks: IPrivacyLinksModel) {
      context.commit('updatePrivacyLinks', privacyLinks);
    },
    updatePlatformName(context, platformName: string) {
      context.commit('updatePlatformName', platformName);
    }
  }
});
